import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environment/environment';

/**
 * Api is a generic REST Api handler. Set your API url first.
 */
@Injectable()
export class Api {
  url: string = environment.baseUrl;

  constructor(public http: HttpClient) {}

  gets(endpoint: string, params?: any) {
    return this.http.post<any>(this.url + '/' + endpoint, params);
  }

  get(endpoint: string, params?: string) {
    return this.http.get<any>(this.url + '/' + endpoint + '/' + params);
  }

  post(endpoint: string, body: any, reqOpts?: any) {
    return this.http.post<any>(this.url + '/' + endpoint, body, reqOpts);
  }

  put(endpoint: string, body: any, reqOpts?: any) {
    return this.http.put<any>(this.url + '/' + endpoint, body, reqOpts);
  }

  delete(endpoint: string, reqOpts?: any) {
    return this.http.delete<any>(this.url + '/' + endpoint, reqOpts);
  }
}



// WEBPACK FOOTER //
// ./src/providers/api/api.ts